// ============================================================================
// DUPLICATED LOGIC: also implemented in backend/app/jobs/model/properties.py.
// Change both and update the parity fixtures in shared/vectors/school_properties.json.
// Why: each map school requests its own property set. Genius has no buffer-pH
// model, so it must not ask for `bph`. The browser and the server read one table.
// ============================================================================

export const M1_PROPERTIES = ["ph", "om", "cec", "p", "k"] as const;

export type MapSchool = "idw" | "zones_flat" | "ml" | "genius_zones";

export type SoilMapProp = (typeof M1_PROPERTIES)[number] | "bph";

/* * Properties each school writes. `ml` is a Genius Map (method omitted on the wire). */
export const SCHOOL_PROPERTIES: Record<MapSchool, readonly SoilMapProp[]> = {
  idw: [...M1_PROPERTIES, "bph"],
  zones_flat: [...M1_PROPERTIES, "bph"],
  ml: [...M1_PROPERTIES],
  genius_zones: [...M1_PROPERTIES],
};

export function schoolProps(
  method: MapSchool | null | undefined,
): readonly SoilMapProp[] {
  if (method == null) return SCHOOL_PROPERTIES.ml;
  return SCHOOL_PROPERTIES[method];
}

/* * One label map. Story copy and the layer list read these, not a second spelling. */
export const SOIL_PROP_LABEL: Record<SoilMapProp, string> = {
  ph: "pH",
  om: "OM",
  cec: "CEC",
  p: "P",
  k: "K",
  bph: "Buffer pH",
};

/* * Spoken step for the soil-map animation. Genius (`ml`) never includes buffer pH. */
export function calculatingStep(prop: SoilMapProp): string {
  switch (prop) {
    case "ph":
      return "Calculating pH…";
    case "om":
      return "Calculating Organic Matter…";
    case "cec":
      return "Calculating CEC…";
    case "p":
      return "Calculating Phosphorus…";
    case "k":
      return "Calculating Potassium…";
    case "bph":
      return "Calculating Buffer pH…";
  }
}
